module.exports = __webpack_public_path__ + "static/media/Manzana.006210f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/NoAvailable/Manzana.svg
// module id = 1818
// module chunks = 0